import React from "react";

const ProgressBar = props => (
    <div className="adobe-progress-bar">
        <i className="fa fa-spinner fa-spin" /> {props.message}
    </div>
);

export default ProgressBar;
